// extracted by mini-css-extract-plugin
module.exports = {"screenshot":"HeaderScreenshot_screenshot__kAW9v","dune":"HeaderScreenshot_dune__gLu_7"};